import { Component } from 'react';
import PropTypes from 'prop-types';
import _throttle from 'lodash/throttle';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { Link } from '@zola/zola-ui/src/components/Link';
import * as toastsActions from '@zola-helpers/client/dist/es/redux/toasts/toastsActions';
import ProductTilesContainer from '../../components/common/shop/ProductTile/ProductTilesContainer';
import {
  getProductListViewedEventData,
  getProductAddedEventData,
  getRegistryItemAddedEventData,
} from './helpers';
import {
  trackProductListViewed,
  trackProductAdded,
  trackRegistryItemAdded,
} from '../../util/trackingHelper';
import '../../../node_modules/slick-carousel/slick/slick.css';
import './ProductsCarousel.less';

const scrollEventsCalled = {
  fat: false,
  'brand-related': false,
  'also-added-skus': false,
};
export default class ProductsCarousel extends Component {
  constructor(props) {
    super();
    this.state = {
      products: props.products || [],
      type: props.type,
      showAdded: [false, false],
      eventData: getProductListViewedEventData(
        props.products,
        props.location,
        props.type,
        props.endpointVariant
      ),
    };
    this.state.sliderSettings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    };

    // FAT helpers
    this.addBothToCart = this.addBothToCart.bind(this);
    this.addBothToRegistry = this.addBothToRegistry.bind(this);
    this.resetShowAdded = this.resetShowAdded.bind(this);
    this.handleFatProductUpdate = this.handleFatProductUpdate.bind(this);
    this.fatProductRequests = {};
  }

  getCarouselHeaderText(type, productData) {
    switch (type) {
      case 'also-added-skus':
        return 'Couples Who Added This Item Also Added';
      case 'frequently-added-together-skus':
        return 'Frequently Added Together';
      case 'brand-related':
        return `More From ${productData.brand.name}`;
      default:
        return '';
    }
  }

  handleFatProductUpdate(index, skuId, quantity) {
    const requestBody = { sku_id: skuId, quantity };
    this.fatProductRequests[index] = requestBody;
  }

  addBothToCart() {
    const { dispatch, addItem, productData, products, location, type, endpointVariant } =
      this.props;
    const firstReq = { item_origin: 'ECOMMERCE', ...this.fatProductRequests[0] };
    const secondReq = { item_origin: 'ECOMMERCE', ...this.fatProductRequests[1] };
    const fatExtraEventData = {
      section: 'RECOMMENDATION_FREQUENTLY_ADDED_TOGETHER',
      recommendation_source: type,
      endpoint_variant: endpointVariant,
    };
    dispatch(addItem(firstReq)).then((firstRes) => {
      if (firstRes && firstRes.payload) {
        const { payload } = firstRes;
        const productLook = productData.product_look_views[0];
        const extraData = Object.assign({}, fatExtraEventData);
        extraData.product_id = productData.id;
        const firstEventData = getProductAddedEventData(
          productData,
          productLook,
          0,
          firstReq.quantity,
          payload.cart_id,
          location,
          null,
          extraData
        );
        trackProductAdded(firstEventData);
      }
      dispatch(addItem(secondReq)).then((secondRes) => {
        if (secondRes && secondRes.payload) {
          const { payload } = secondRes;
          const productLook = products[0].product_look_views[0];
          const extraData = Object.assign({}, fatExtraEventData);
          extraData.product_id = products[0].id;
          const secondEventData = getProductAddedEventData(
            products[0],
            productLook,
            0,
            secondReq.quantity,
            payload.cart_id,
            location,
            null,
            extraData
          );
          trackProductAdded(secondEventData);
        }
        window.dispatchEvent(new CustomEvent('OPEN_MODAL_EVENT', { detail: 'CART' }));
      });
    });
  }

  addBothToRegistry() {
    const {
      dispatch,
      addToRegistry,
      userContext,
      productData,
      products,
      location,
      type,
      endpointVariant,
    } = this.props;
    if (userContext.is_guest) {
      return window.zolaNav.openSignupModal();
    }
    if (!userContext.is_guest && !userContext.has_registry) {
      window.location.href = '/onboard/new';
      return null;
    }
    const userId = userContext.object_id;
    const registryId = userContext.registry_account && userContext.registry_account.registry_id;
    const baseReq = {
      registry_id: registryId,
      user_id: userId,
      enable_group_gifting: false,
    };
    const firstReq = { ...baseReq, ...this.fatProductRequests[0] };
    const secondReq = { ...baseReq, ...this.fatProductRequests[1] };
    const fatExtraEventData = {
      section: 'RECOMMENDATION_FREQUENTLY_ADDED_TOGETHER',
      recommendation_source: type,
      endpoint_variant: endpointVariant,
    };
    if (
      userContext &&
      userContext.user_role_account_weddings &&
      userContext.user_role_account_weddings[0]
    ) {
      const { slug } = userContext.user_role_account_weddings[0];
      const headline = (
        <div className="addedToRegistryToast">
          <span>2 Added to Your Registry</span>
          <Link className="registryCta" href={`/registry/${slug}`}>
            View Registry
          </Link>
        </div>
      );
      dispatch(toastsActions.positive({ headline }));
    }
    return dispatch(
      addToRegistry(firstReq, productData.shipping_zones, productData.shipping_excluded_states)
    ).then((firstRes) => {
      if (firstRes) {
        const productLook = productData.product_look_views[0];
        const firstEventData = getRegistryItemAddedEventData({
          productData,
          activeProductLook: productLook,
          activeSku: 0,
          quantity: firstReq.quantity,
          location,
          extraData: fatExtraEventData,
        });
        trackRegistryItemAdded(firstEventData);
      }
      dispatch(
        addToRegistry(secondReq, productData.shipping_zones, productData.shipping_excluded_states)
      ).then((secondRes) => {
        if (secondRes) {
          const productLook = products[0].product_look_views[0];
          const secondEventData = getRegistryItemAddedEventData({
            productData: products[0],
            activeProductLook: productLook,
            activeSku: 0,
            quantity: secondReq.quantity,
            location,
            extraData: fatExtraEventData,
          });
          trackRegistryItemAdded(secondEventData);
        }
        this.setState({ showAdded: [true, true] });
      });
    });
  }

  resetShowAdded(index) {
    const { showAdded } = this.state;
    showAdded[index] = false;
    this.setState({ showAdded });
  }

  renderFrequentlyAddedTogether(fatProduct, productData) {
    const { showAdded } = this.state;
    const { location, type, endpointVariant } = this.props;
    const fatEventData = getProductListViewedEventData([fatProduct, productData], location, type);
    const baseEventData = {
      location,
      section: 'RECOMMENDATION_FREQUENTLY_ADDED_TOGETHER',
      recommendation_source: type,
      endpoint_variant: endpointVariant,
    };
    const fatCarouselScrollListener = () => {
      const carousel = document.getElementById('fat-carousel');
      if (!carousel) return;
      const { y } = carousel.getBoundingClientRect();
      if (y * 2 < window.innerHeight && !scrollEventsCalled.fat) {
        scrollEventsCalled.fat = true;
        trackProductListViewed(fatEventData);
        window.removeEventListener('scroll', fatCarouselScrollListener);
      }
    };
    window.addEventListener('scroll', _throttle(fatCarouselScrollListener, 750));
    const spacer = <div className="fat-products-plus">+</div>;
    return (
      <div className="products-carousel_container" id="fat-carousel">
        <h2 className="products-carousel-header">Frequently Added Together</h2>
        <div className="fat-content_container">
          <div className="fat-products-tiles_container">
            <ProductTilesContainer
              startIndex={0}
              isBVSEOEnable={false}
              eventData={baseEventData}
              products={[productData, fatProduct]}
              isAddedStampVisibleOverride={showAdded}
              fatProductUpdateCallback={this.handleFatProductUpdate}
              fatHoverCallback={this.resetShowAdded}
              tilesSpacer={spacer}
            />
          </div>
          <div className="fat-products-button_container">
            <div className="fat-buttons-header">Want both?</div>
            <ButtonV2
              onClick={this.addBothToRegistry}
              type="submit"
              className="fat-add-registry-button"
            >
              <div>Add Both To Registry</div>
            </ButtonV2>
            <ButtonV2
              onClick={this.addBothToCart}
              type="submit"
              variant="secondary"
              className="fat-add-cart-button"
            >
              <div>Add Both To Cart</div>
            </ButtonV2>
            {showAdded[0] && showAdded[1] ? (
              <div className="added-registry-notification">
                <div>2 items added to your registry.</div>
                <Link rel="noopener noreferrer" target="_blank" href="/my-registry">
                  View Registry
                </Link>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { sliderSettings, products, type, eventData } = this.state;
    const { productData, location, section, endpointVariant } = this.props;
    const extraEventData = { location, section };
    if (type === 'also-added-skus') {
      extraEventData.recommendation_source = type;
      extraEventData.endpoint_variant = endpointVariant;
    }
    if (!productData) return null;
    if (type === 'frequently-added-together-skus') {
      const fatProduct = products[0];
      return this.renderFrequentlyAddedTogether(fatProduct, productData);
    }
    const carouselScrollListener = () => {
      const carousel = document.getElementById(`${type}-carousel`);
      if (!carousel) return;
      const { y } = carousel.getBoundingClientRect();
      if (y * 2 < window.innerHeight && !scrollEventsCalled[type]) {
        scrollEventsCalled[type] = true;
        trackProductListViewed(eventData);
        window.removeEventListener('scroll', carouselScrollListener);
      }
    };
    window.addEventListener('scroll', _throttle(carouselScrollListener, 750));

    return (
      <div className="products-carousel_container" id={`${type}-carousel`}>
        <h2 className="products-carousel-header">
          {this.getCarouselHeaderText(type, productData)}
          {type === 'brand-related' ? (
            <Link arrow href={`/shop/brand/${productData.brand.key}`}>
              See All
            </Link>
          ) : null}
        </h2>
        <ProductTilesContainer
          isBVSEOEnable={false}
          hasCategoryLink
          startIndex={0}
          sliderSettings={sliderSettings}
          eventData={extraEventData}
          products={products}
        />
      </div>
    );
  }
}

ProductsCarousel.propTypes = {
  endpointVariant: PropTypes.string,
  location: PropTypes.string,
  section: PropTypes.string,
  type: PropTypes.string,
  productData: PropTypes.shape({}),
  userContext: PropTypes.shape({}),
  products: PropTypes.arrayOf(PropTypes.shape({})),
  dispatch: PropTypes.func,
  addItem: PropTypes.func,
  addToRegistry: PropTypes.func,
};
